import { Factory } from 'miragejs';
import { faker } from '@faker-js/faker';
import pairablePrinters from 'garaje/utils/pairable-printers';

const PRINTER_MODELS = pairablePrinters.map((p) => p.printerModel);
const PRINTER_STATES = ['out_of_paper', 'error', 'idle', 'offline', 'online'];

export default Factory.extend({
  name(i) {
    return `${PRINTER_MODELS[i % PRINTER_MODELS.length]}: ${i + 1}`;
  },

  state: () => faker.helpers.arrayElement(PRINTER_STATES),

  createdAt: () => new Date(),

  afterCreate(printerConnectionOption, server) {
    if (!printerConnectionOption.parentId) {
      printerConnectionOption.update({
        parentId: server.create('printer-connection').id,
      });
    }
  },
});
